export default __webpack_public_path__ + "static/media/dataGovernance.e797f04a.svg";